import { sectorSliceHalfHeight } from './sectorSliceSurface.js';
function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
export function computeSectorRingLabelGeometryByItemKey(args) {
    const { layout, items, labelLayoutPolicy } = args;
    const out = new Map();
    if (items.length === 0)
        return out;
    const minFontSize = labelLayoutPolicy?.minFontSize ?? 0.3;
    const maxFontSize = labelLayoutPolicy?.maxFontSize ?? 1.1;
    const yOffset = labelLayoutPolicy?.yOffset ?? 0.02;
    const sizePolicy = labelLayoutPolicy?.sizePolicy ?? 'layout-default';
    const placement = labelLayoutPolicy?.placement ?? 'layout-default';
    let computedFontSize = clamp(minFontSize, minFontSize, maxFontSize);
    let computedOffset = [0, yOffset, 0];
    if (sizePolicy === 'fit-available-space' || sizePolicy === 'layout-default') {
        const innerRadius = layout.innerRadius ?? 0;
        const outerRadius = layout.outerRadius;
        const radialT = placement === 'centered' ? 0.5 : 0.7;
        const radial = innerRadius + (outerRadius - innerRadius) * radialT;
        const itemCount = items.length;
        const slotSpan = itemCount <= 1 ? Math.PI * 2 : (Math.PI * 2) / itemCount;
        const gapFraction = clamp(layout.angularGapFraction ?? 0.16, 0, 0.95);
        const span = slotSpan * (1 - gapFraction);
        const availableArcWidth = radial * span;
        const rawFontSize = availableArcWidth * 0.10;
        computedFontSize = clamp(rawFontSize, minFontSize, maxFontSize);
        computedOffset = [0, yOffset + sectorSliceHalfHeight(innerRadius, outerRadius, layout.outerThickness, radial, layout.thicknessProfile), radial];
    }
    for (const item of items) {
        out.set(item.itemKey, {
            fontSize: computedFontSize,
            offset: computedOffset,
        });
    }
    return out;
}
